import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { InvoiceService } from '../../Services/invoice.service';
import { FileDownloadService } from 'src/app/services/file-download.service';
import { InvoiceAddendum } from '../../Services/invoiceAddendumListViewModel';
import { PropertyService } from 'src/app/property-module/services/property.service';
import { ClientLocationDropDownValue } from 'src/app/clients-module/models/clientLocation';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-addendum-upload',
  templateUrl: './addendum-upload.component.html',
  styleUrls: ['./addendum-upload.component.less']
})
export class AddendumUploadComponent implements OnInit {
  @ViewChild('addendumUpload', {}) ngForm: NgForm;
  constructor(
    public readonly modalService: NgbModal,
    private toasterService: ToastrService,
    private readonly invoiceService: InvoiceService,
    private fileDownload: FileDownloadService,
    private properties : PropertyService
  ) { }

  model : InvoiceAddendum = new InvoiceAddendum();
  props : ClientLocationDropDownValue[];
  processing : boolean = true;
  ngOnInit(): void {
    // throw new Error("Method not implemented.");
    this.properties.FetchAllPropertiesDropDownDataForUser().subscribe((scc: any)=>{
      this.props = scc;
    }, ()=>{ this.toasterService.error('Error loading locations', '')}, ()=>{
      this.processing = false;
    })
  }


  cancel() : void {
    this.modalService.dismissAll();
  }


  download(){
    if(this.ngForm.form.status == 'VALID'){
      console.log(this.model);
      console.log(this.ngForm);
      this.invoiceService.saveInvoiceAddendum(this.model).subscribe((addy: InvoiceAddendum)=>{
        this.toasterService.success('Addendum Created');
        this.modalService.dismissAll();
      },()=>{
        this.toasterService.error('Addendum Save Failed');
      })
    }
  }
}
